module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"notice_detail":"공지사항 자세히 보기"}}')
  delete Component.options._Ctor
}
